import SiteDetails from './SiteDetails'

export default SiteDetails
